import { combineReducers } from "@reduxjs/toolkit";
import workerRootReducer from "../Workers/rootReducer/rootReducer";

const rootReducer = combineReducers({
    ...workerRootReducer,
});

export default rootReducer;